export const monthMap: { [key: string]: number } = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11,
}

export const TIMEZONE_OPTIONS = [
  { value: 'Etc/GMT+12', label: 'GMT-12:00 - International Date Line West' },
  { value: 'Pacific/Pago_Pago', label: 'GMT-11:00 - American Samoa' },
  { value: 'Pacific/Honolulu', label: 'GMT-10:00 - Hawaii' },
  { value: 'Pacific/Marquesas', label: 'GMT-09:30 - Marquesas Islands' },
  { value: 'America/Anchorage', label: 'GMT-09:00 - Alaska' },
  {
    value: 'America/Los_Angeles',
    label: 'GMT-08:00 - Pacific (US & Canada) Los Angeles',
  },
  {
    value: 'America/Denver',
    label: 'GMT-07:00 - Mountain (US & Canada) Denver',
  },
  {
    value: 'America/Chicago',
    label: 'GMT-06:00 - Central (US & Canada) Chicago',
  },
  {
    value: 'America/New_York',
    label: 'GMT-05:00 - Eastern (US & Canada) New York',
  },
  { value: 'America/Caracas', label: 'GMT-04:30 - Caracas' },
  { value: 'America/Halifax', label: 'GMT-04:00 - Atlantic (Canada) Halifax' },
  { value: 'America/St_Johns', label: 'GMT-03:30 - Newfoundland' },
  {
    value: 'America/Argentina/Buenos_Aires',
    label: 'GMT-03:00 - Buenos Aires',
  },
  { value: 'America/Noronha', label: 'GMT-02:00 - Mid-Atlantic' },
  { value: 'Atlantic/Azores', label: 'GMT-01:00 - Azores' },
  { value: 'UTC', label: 'GMT+00:00 - UTC' },
  { value: 'Europe/London', label: 'GMT+00:00 - London' },
  { value: 'Europe/Paris', label: 'GMT+01:00 - Central Europe Paris' },
  { value: 'Europe/Athens', label: 'GMT+02:00 - Eastern Europe Athens' },
  { value: 'Europe/Moscow', label: 'GMT+03:00 - Moscow' },
  { value: 'Asia/Tehran', label: 'GMT+03:30 - Tehran' },
  { value: 'Asia/Dubai', label: 'GMT+04:00 - Dubai' },
  { value: 'Asia/Kabul', label: 'GMT+04:30 - Kabul' },
  { value: 'Asia/Karachi', label: 'GMT+05:00 - Pakistan Karachi' },
  { value: 'Asia/Kolkata', label: 'GMT+05:30 - India Kolkata' },
  { value: 'Asia/Kathmandu', label: 'GMT+05:45 - Nepal Kathmandu' },
  { value: 'Asia/Dhaka', label: 'GMT+06:00 - Bangladesh Dhaka' },
  { value: 'Asia/Rangoon', label: 'GMT+06:30 - Myanmar Yangon' },
  { value: 'Asia/Bangkok', label: 'GMT+07:00 - Indochina Bangkok' },
  { value: 'Asia/Shanghai', label: 'GMT+08:00 - China Shanghai' },
  { value: 'Asia/Manila', label: 'GMT+08:00 - Philippines Manila' },
  { value: 'Asia/Tokyo', label: 'GMT+09:00 - Japan Tokyo' },
  { value: 'Australia/Adelaide', label: 'GMT+09:30 - Australia Adelaide' },
  { value: 'Australia/Sydney', label: 'GMT+10:00 - Australia Sydney' },
  { value: 'Pacific/Guadalcanal', label: 'GMT+11:00 - Solomon Islands' },
  { value: 'Pacific/Auckland', label: 'GMT+12:00 - New Zealand Auckland' },
  { value: 'Pacific/Chatham', label: 'GMT+12:45 - Chatham Islands' },
  { value: 'Pacific/Tongatapu', label: 'GMT+13:00 - Tonga' },
  { value: 'Pacific/Kiritimati', label: 'GMT+14:00 - Line Islands' },
]

export const fullDaysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]
